import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { ExpertCardContent } from "../../pro/Listing/components/ExpertCardContent";

interface Props {
  pro: any;
  isSelected: boolean;
  isAlreadyAdded?: boolean;
  onSelect: (proId: number, isChecked: boolean) => void;
}

export default function ShortlistProCard({
  pro,
  isSelected,
  isAlreadyAdded,
  onSelect,
}: Props) {
  const [isChecked, setIsChecked] = useState(isSelected);

  useEffect(() => {
    setIsChecked(isSelected);
  }, [isSelected]);

  const handleSelect = () => {
    const newCheckedState = !isChecked;
    setIsChecked(newCheckedState);
    onSelect(pro.userid, newCheckedState);
  };

  return (
    <div
      className={classNames(
        "py-4 px-4 flex flex-col border-b border-border-token w-full cursor-pointer transition-all duration-200 relative",
        {
          "bg-surface": !isChecked,
          "bg-tint border-[#E4CBA8] rounded-lg": isChecked,
          hidden: isAlreadyAdded,
        }
      )}
      onClick={() => !isAlreadyAdded && handleSelect()}
    >
      {isChecked && (
        <div className="absolute right-4 top-[3.5rem]">
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.8002 8.90039L9.64068 16.1004L7.2002 13.6461"
              style={{ stroke: 'var(--accent)' }}
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      )}

      <ExpertCardContent pro={pro} />
    </div>
  );
}
